import React, { useEffect, useRef, useState } from "react";
import "./About.css";

import img1 from "../../assets/images/projects/img4.png";

const AboutSplit = () => {
  const impactRef = useRef(null);
  const [start, setStart] = useState(false);

  const [counts, setCounts] = useState({
    years: 0,
    projects: 0,
    acres: 0,
    customers: 0,
  });

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setStart(true);
        }
      },
      { threshold: 0.4 }
    );

    if (impactRef.current) {
      observer.observe(impactRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!start) return;

    const animate = (key, target, duration) => {
      let startTime = null;

      const step = (currentTime) => {
        if (!startTime) startTime = currentTime;
        const progress = currentTime - startTime;

        const value = Math.min(
          Math.floor((progress / duration) * target),
          target
        );

        setCounts((prev) => ({ ...prev, [key]: value }));

        if (progress < duration) {
          requestAnimationFrame(step);
        }
      };

      requestAnimationFrame(step);
    };

    animate("years", 10, 1500);
    animate("projects", 25, 1500);
    animate("acres", 50, 1500);
    animate("customers", 1000, 2000);
  }, [start]);

  return (
    <section className="about-split" id="about">

      {/* 🔥 CONTENT */}
      <div className="about-content-container">
        <div className="about-content">
          <span className="about-eyebrow">ABOUT US</span>

      
          <h2>
            Building Tomorrow’s Spaces With Today’s Intelligence.
          </h2>

          <h3>OUR STORY – A NEW WAY FORWARD</h3>

          <p>
            Today, Jayaram Infracon stands as a new kind of development partner—
            one that blends data with design, precision with empathy, and
            innovation with long-term thinking.
          </p>

          <p>
            We’re not just creating projects. We’re shaping places where people
            feel grounded, connected, and confident.
          </p>

          <p>
          Whether you are a first-time buyer or a seasoned investor, Jayaram Group delivers opportunities that align with your financial goals and future vision
          </p>

          <p>
          
          
          With a strong focus on North Bangalore’s rapid expansion corridor, we bring exclusive access to high-potential projects, ensuring maximum appreciation and long-term returns</p>
          <p>Our approach is simple — transparency, trust, and performance.</p>
        </div>


      </div>

      {/* 🔥 IMAGE */}
      <div className="about-image-wrapper">
        <img src={img1} alt="About" />
      </div>

      {/* 🔥 IMPACT */}
      <div className="about-impact" ref={impactRef}>
        <div className="impact">
          <h3>{counts.years}+</h3>
          <p>Years of Excellence</p>
        </div>

        <div className="impact">
          <h3>{counts.projects}+</h3>
          <p>Projects Delivered</p>
        </div>

        <div className="impact">
          <h3>{counts.acres}+</h3>
          <p>Acres Developed</p>
        </div>

        <div className="impact">
          <h3>{counts.customers}+</h3>
          <p>Happy Customers</p>
        </div>
      </div>

    </section>
  );
};

export default AboutSplit;